export function isVindiPaymentGateway(paymentGateway: string | null | undefined): boolean {
    return paymentGateway?.toLowerCase() === "vindi";
}
